<div *transloco="let t">
	<ng-container>
		<div class="px-12 flex flex-col">
			<div class="pt-6 pb-3 title">
				{{ t('userProfile.editUserProfile') }}
			</div>
		</div>
		<div class="px-12 flex flex-wrap flex-row {{ isMobile() ? 'w-full' : 'w-2/3' }}">
			<div class="{{ isMobile() ? 'w-full' : 'w-1/3' }} mr-1">
				<mat-form-field [ngClass]="'w-full'" appearance="fill">
					<mat-label>{{ t('userProfile.firstName') }}</mat-label>
					<input (keyup)="validateInput()" [formControl]="firstNameFC" matInput />
					<mat-error>{{ t('common.markedRequired') }}</mat-error>
				</mat-form-field>
			</div>
			<div class="{{ isMobile() ? 'w-full' : 'w-1/3' }}">
				<mat-form-field [ngClass]="'w-full'" appearance="fill">
					<mat-label>{{ t('userProfile.lastName') }}</mat-label>
					<input (keyup)="validateInput()" [formControl]="lastNameFC" matInput />
					<mat-error>{{ t('common.markedRequired') }}</mat-error>
				</mat-form-field>
			</div>
		</div>
	</ng-container>
</div>
